module.exports = __webpack_public_path__ + "img/back6.d0328978.png";